import { useEffect, useState } from 'react';
import { Banner, Footer, Navbar } from '../components';
import { Typography } from '@material-tailwind/react';
import MapContainer from '../components/MapContainer';
import ubiarea from "../assets/images/area.webp"
import { useParams } from 'react-router-dom';
import sessionData from '../assets/jsons/sessions_data.json';

interface SessionPageProps {
}

export function SessionPage({ }: SessionPageProps) {
  const { id } = useParams(); // Get session ID from the URL
  const [sessionPapers, setSessionPapers] = useState<any>([]);
  const [navbarTransparent, setNavbarTransparent] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      // Set navbar to not transparent if the scroll position is more than 100px
      const shouldNavbarBeTransparent = window.scrollY < 100;
      setNavbarTransparent(shouldNavbarBeTransparent);
    };

    // Add event listener for scroll
    window.addEventListener('scroll', handleScroll);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // @ts-expect-error
    const sessionPapers = sessionData.sessions[id] || [];
    setSessionPapers(sessionPapers);

  }, [id]);
  return (
    <>
      <div className="w-full relative">
        <Navbar transparent={navbarTransparent} />
        <Banner title={`Session ${id}`} />

        <section className="w-full container mx-auto px-2 lg:px-14" >

          <div className="flex flex-col justify-center  w-full h-full p-8">
            <Typography variant="h3" color="blue-gray" className="mb-2">
              Papers
            </Typography>
            {sessionPapers.length > 0 ? (
              <div>
                {sessionPapers.map((paper: any) => (
                  <>
                    <Typography color="gray" className="font-bold mt-8">
                      {paper.title}
                    </Typography>
                    <ul className="list-disc font-normal mt-4 pl-4" >
                      {paper.authors.map((p: any, index: any) => (
                        <li key={`${paper.paper_id}_${index}`}>{p}</li>
                      ))}
                    </ul>
                  </>
                ))}
              </div>

            ) : (
              <p>No papers found for this session.</p>
            )}

          </div>

        </section>


        <Footer />

      </div>

    </>
  );
}
